module.exports = __webpack_public_path__ + "img/LinkUpAnchorNEW.826a4639.png";